exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-add-criteria[data-v-20f9749d]{position:absolute;right:0;top:15px;width:40px;height:40px}#modal-add-criteria input[type=text][data-v-20f9749d],#modal-add-criteria textarea[data-v-20f9749d]{border:1px #cecece;background:#f1f1f1;box-shadow:none}", ""]);

// exports
